/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './index.module.scss';

const { inline, slim } = styles;

const AccionaBigButton = ({ msg, icon, onClick, disable, display, size }) => (
  <div
    className={`home-button ${icon} ${disable ? 'disabled' : ''} ${display === 'inline' ? inline : ''} ${size === 'slim' ? slim : ''}`}
  >
    <a
      className="home-button"
      id="AccionaBigUploadButton"
      onClick={() => {
        if (!disable) {
          onClick();
        }
      }}
    >
      <div className="image-btn"> </div>
      <span> {msg}</span>
    </a>
  </div>
);

AccionaBigButton.propTypes = {
  msg: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  disable: PropTypes.bool,
  display: PropTypes.oneOf(['inline', 'block']),
  size: PropTypes.oneOf(['slim', 'normal']),
};

AccionaBigButton.defaultProps = {
  msg: 'UPLOAD',
  icon: 'data',
  disable: false,
  display: 'block',
  size: 'normal',
};

export default AccionaBigButton;
